import { render, staticRenderFns } from "./devWarnWx.vue?vue&type=template&id=c20f3b60&scoped=true&"
import script from "./devWarnWx.vue?vue&type=script&lang=js&"
export * from "./devWarnWx.vue?vue&type=script&lang=js&"
import style0 from "./devWarnWx.vue?vue&type=style&index=0&id=c20f3b60&scoped=true&lang=css&"
import style1 from "./devWarnWx.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20f3b60",
  null
  
)

export default component.exports